import React from 'react';
import PropTypes from 'prop-types';
import styles from '../CheckBoxFilters.module.scss';
import Icon from 'components/Icon/Icon';

function ExperienceLevelCheckBox({
  experienceLevel,
  onExperienceLevelToggle,
  checked,
}) {
  return (
    <div onClick={onExperienceLevelToggle} className={styles.checkBoxContainer}>
      <div className={styles.checkBoxIcon}>
        {checked && <Icon icon="&#xe60c;" color="#0ee2b0" />}
      </div>

      <div className={styles.checkBoxLabel}>
        <div className={styles.flexContainer}>{experienceLevel.label}</div>
      </div>
    </div>
  );
}

ExperienceLevelCheckBox.propTypes = {
  experienceLevel: PropTypes.object,
  onExperienceLevelToggle: PropTypes.func,
  checked: PropTypes.bool,
};

export default ExperienceLevelCheckBox;
